import * as React from 'react';

import { Box, Button, Flex, H3 } from '@opendoor/bricks/core';
import Input from '@opendoor/bricks/core/Input';
import { IAddressInputAddress } from '@opendoor/cinderblocks/growth/AddressInput/AddressInput';

interface IManualAddressPageProps {
  addressInput: IAddressInputAddress | null;
  cancelManualAddressVerification: (hasAddressInput: boolean) => void;
  modifyAddress: (address: IAddressInputAddress) => void;
}

interface IState {
  address: IAddressInputAddress;
  loadingSubmit: boolean;
}

export class ManualAddressPage extends React.PureComponent<IManualAddressPageProps, IState> {
  public state: IState = {
    address: this.props.addressInput || ({} as IAddressInputAddress),
    loadingSubmit: false,
  };

  public render() {
    const { address } = this.state;
    return (
      <Box flex={['1 0 auto', null, '0 1 auto']}>
        <H3 width="100%" textAlign={['center', null, 'left']} mb={7}>
          What's your address?
        </H3>
        <Flex flexDirection="column" width="100%" mb={7}>
          <Flex flexDirection={['column', null, 'row']} mb={6}>
            <Box flex={2} mr={[null, null, 4]} mb={[3, null, 0]}>
              <Input
                analyticsName="cosmos-manual-address-page-street"
                id="street1"
                name="street1"
                value={address.street1}
                onChange={(_event, value) => this.handleOnChange('street1', value)}
                placeholder="Street Address"
                aria-label="Street Address"
                type="text"
                unboundedWidth
              />
            </Box>
            <Box flex={1}>
              <Input
                analyticsName="cosmos-manual-address-page-unit-number"
                id="unit"
                name="unit"
                value={address.unit}
                onChange={(_event, value) => this.handleOnChange('unit', value)}
                placeholder="Unit Number"
                aria-label="Unit Number"
                type="text"
                unboundedWidth
              />
            </Box>
          </Flex>

          <Flex flexDirection={['column', null, 'row']}>
            <Flex
              flexDirection={['column', null, 'row']}
              flex={2}
              mr={[null, null, 4]}
              mb={[3, null, 0]}
            >
              <Box flex={2} mr={[null, null, 4]} mb={[3, null, 0]}>
                <Input
                  analyticsName="cosmos-manual-address-page-city"
                  id="city"
                  name="city"
                  value={address.city}
                  onChange={(_event, value) => this.handleOnChange('city', value)}
                  placeholder="City"
                  aria-label="City"
                  type="text"
                  unboundedWidth
                />
              </Box>
              <Box flex={1}>
                <Input
                  analyticsName="cosmos-manual-address-page-state"
                  id="state"
                  name="state"
                  value={address.state}
                  onChange={(_event, value) => this.handleOnChange('state', value)}
                  placeholder="State"
                  aria-label="State"
                  type="text"
                  unboundedWidth
                />
              </Box>
            </Flex>
            <Box flex={1}>
              <Input
                analyticsName="cosmos-manual-address-page-postal-code"
                id="postal_code"
                name="postal_code"
                value={address.postal_code}
                onChange={(_event, value) => this.handleOnChange('postal_code', value)}
                placeholder="Postal Code"
                aria-label="Postal Code"
                type="text"
                unboundedWidth
              />
            </Box>
          </Flex>
        </Flex>

        <Flex flexDirection={['column', null, 'row']}>
          <Button
            onClick={this.handleModifyAddress}
            disabled={!address.street1 || !address.city || !address.state || !address.postal_code}
            mr={[null, null, 4]}
            mb={[3, null, 0]}
            loading={this.state.loadingSubmit}
            aria-label="Submit modified address"
            analyticsName="cosmos-manual-address-page-submit-modified-address"
          >
            Continue
          </Button>
          <Button
            variant="secondary"
            onClick={this.handleCancel}
            aria-label="Cancel address modification"
            analyticsName="cosmos-manual-address-page-cancel-address-modification"
          >
            Cancel
          </Button>
        </Flex>
      </Box>
    );
  }

  private handleOnChange = (name: string, value?: string | null) => {
    const { address } = this.state;
    this.setState({ address: { ...address, [name]: value } });
  };

  private handleModifyAddress = () => {
    this.setState({ loadingSubmit: true });
    this.props.modifyAddress(this.state.address);
  };

  private handleCancel = () => {
    this.props.cancelManualAddressVerification(!!this.props.addressInput);
  };
}
